import call from "../../../api/call";
import type { GlobalRole } from "../../../api/useUser";

const updateGlobalRole = (userId: string, globalRole: GlobalRole | null) =>
  call("POST", "/users/:userId(uuid)/roles/global", {
    routeParams: {
      userId: encodeURI(userId),
    },
    body: { role: globalRole },
  });

export default updateGlobalRole;
